function initCollectionSwipers() {
    document.querySelectorAll('.swiper-nav-collections').forEach((el) => {
        new Swiper(el, {
            direction: 'horizontal',
            slidesPerView: 3,
            spaceBetween: 0,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
            },
            grabCursor: true,
        });
    });
}


window.addEventListener('load', () => {
    initCollectionSwipers();
});
